/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cropper-wrapper[_ngcontent-%COMP%]{max-width:1084px;max-height:610px}.dropFile[_ngcontent-%COMP%]{width:100%;height:610px;max-width:1084px;max-height:610px;border:2px dashed #d0d0d0}.innerFile[_ngcontent-%COMP%]{width:100%;height:610px;max-width:1084px;max-height:610px;opacity:0;cursor:pointer}.dropText[_ngcontent-%COMP%]{position:absolute;text-align:center;left:45%;top:47.5%}"];
export { styles as styles };
